import React, { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";
import { IMAGES } from "@/lib/content";

const CATS = ["all", "Hookah", "Cocktails", "Food", "Nightlife"];

export default function Gallery() {
  const [cat, setCat] = useState("all");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`/gallery?category=${cat}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [cat]);

  return (
    <>
      <Seo title="Gallery — Nightlife on U Street" description="Step inside ChiCha Lounge DC — hookah, craft cocktails, food and VIP nightlife moments from Washington DC's premier lounge." path="/gallery" image={IMAGES.crowd} />
      <PageHero overline="The Moments" title="Gallery" subtitle="Hookah, cocktails, food and unforgettable nights — captured at ChiCha." image={IMAGES.dj} />

      <section className="pb-28 bg-transparent">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="flex flex-wrap gap-3 mb-12">
            {CATS.map((c) => (
              <button key={c} data-testid={`gallery-cat-${c.toLowerCase()}`} onClick={() => setCat(c)} className={`px-5 py-2 rounded-full text-sm uppercase tracking-wide transition-all ${cat === c ? "bg-neutral-900 text-white" : "glass text-neutral-600"}`}>
                {c === "all" ? "All" : c}
              </button>
            ))}
          </div>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
            {items.map((g, i) => (
              <Reveal key={g.id} delay={(i % 3) * 0.05} className="break-inside-avoid">
                <div className="relative overflow-hidden rounded-xl group">
                  <img src={g.image_url} alt={g.caption || "ChiCha Lounge DC"} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5">
                    <div>
                      <span className="text-white/70 text-[10px] uppercase tracking-widest">{g.category}</span>
                      {g.caption && <p className="text-white font-serif text-lg">{g.caption}</p>}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          {items.length === 0 && <p className="text-neutral-400 py-20 text-center">No images in this category yet.</p>}
        </div>
      </section>
    </>
  );
}
